import { mapState } from 'vuex';
export default {
  name: 'NiotaClassicDevicesDeviceDetailsVisualization',
  props: {
    allRelevantKeys: {
      type: Array,
      required: false,
      default: new Array()
    },
    isLoadingGraph: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    showLoadMorePackets: {
      type: Boolean,
      required: true
    },
    visualizeGraphsToggle: {
      type: Boolean,
      required: true
    },
    dynamicGraph: {
      type: Object,
      required: true
    },
    parsedPacketsSize: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function () {
    return {
      loadingGraph: true,
      limit: 10,
      graphKeys: [],
      graphData: {}
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    isLoadingGraph() {
      this.initData();
    },
    allRelevantKeys() {
      this.initData();
    },
    dynamicGraph() {
      this.initData();
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.loadingGraph = this.isLoadingGraph;
      this.graphKeys = this.allRelevantKeys;
      this.graphData = this.dynamicGraph;
    },
    loadMorePackets() {
      if (this.parsedPacketsSize === this.limit) {
        this.limit += 10;
      }
      this.$emit('loadParsedPackets', this.limit);
    },
    resetPackets() {
      this.limit = 10;
      this.$emit('loadParsedPackets', this.limit);
    }
  }
};